<template>
  <div class="page">
    <div v-if="model != null">
      <van-panel class="panel-info">
        <van-cell slot="header" icon="orders-o" :title="$store.state.OrderTypeEnum.getLabel(model.orderType)"></van-cell>
        <UserCell :model="userCell"
                  :to="'/leader/user/detail/'"
                  :isAuthority="isAuthority('user-manage')"></UserCell>
        <div class="content">
          <div class="row">
            <span class="label">订单号</span>
            <div v-if="isAuthority('order')" @click.stop.prevent="gotoOrderDetail(model.orderId)" style="color: #1989fa">{{model.orderNo}}</div>
            <div v-else >{{model.orderNo}}</div>
          </div>
          <div class="row">
            <span class="label">订单金额</span><span class="value">￥{{formatPrice(model.orderServicePrice)}}</span>
          </div>
          <div v-if="model.type != 'reward'" class="row">
            <span class="label" >订单内容</span>
            <span class="value">
             {{model.itemCategory != null ? model.itemCategory.name + '-' : ''}}
                    {{model.orderItem.names.join('-')}} × {{model.orderNum}}</span>
          </div>
          <div class="row">
            <span class="label">显示状态</span>
            <span class="value">
              <van-tag v-if="model.isShow" plain type="danger" style="margin-right: 5px">显示中</van-tag>
              <van-tag v-if="!model.isShow" plain type="danger" style="margin-right: 5px">已隐藏</van-tag>
              <van-tag v-if="model.isAnonymous" style="margin-left: 5px">匿名评价</van-tag>
            </span>
          </div>
          <div class="row">
            <div class="label">评价店员</div>
            <div class="value">
              <span>{{ model.clerkName }}</span>
            </div>
          </div>
          <div class="row">
            <span class="label">评价时间</span><span class="value">{{formatDate(model.createTime, 'YYYY-MM-DD HH:mm:ss')}}</span>
          </div>
          <div v-if="!$hasFeature('custom_2362')"  class="row">
            <span class="label">评价分数</span>
            <van-rate
                v-model="model.score"
                readonly
                :size="25"
                color="#ffd21e"
                void-icon="star"
                void-color="#eee"
            />
          </div>
          <div v-if="$hasFeature('custom_2362')"  class="detail-row">
            <div><span class="label">评价分数</span></div>
            <div class="item">
              <div>
                <span class="item-label">服务：</span>
                <van-rate
                    v-model="model.score"
                    readonly
                    :size="16"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                />
              </div>
              <div v-if="model.techScore > 0">
                <span class="item-label">技术：</span>
                <van-rate
                    v-model="model.techScore"
                    readonly
                    :size="16"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                />
              </div>
              <div v-if="model.intelligenceScore > 0">
                <span class="item-label">情商：</span>
                <van-rate
                    v-model="model.intelligenceScore"
                    readonly
                    :size="16"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                />
              </div>
              <div v-if="model.emoScore > 0">
                <span class="item-label">情绪价值：</span>
                <van-rate
                    v-model="model.emoScore"
                    readonly
                    :size="16"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <span class="label">评价内容</span><span class="value">{{ model.content }}</span>
          </div>
          <div v-if="$LeaderPermission.isShowOrderRate">
            <van-button
                v-if="model.status != '-1' && model.type != 'reward'"
                @click="updateIsShow(model.id, !model.isShow)"
                block size="normal" type="primary"
                style="margin-top: 20px;background-color: #2d8cf0; border: 1px solid #2d8cf0;"
            >{{model.isShow ? '隐藏评价' : '显示评价'}}</van-button>
          </div>

        </div>

      </van-panel>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Panel, Cell, Button, Tag, Icon, Toast, Dialog, Field, ImagePreview,Image,Rate } from 'vant';
import Decimal from 'decimal.js';
import moment from 'moment';
import { getRate ,updateIsShow} from '@/api/leader/order-rate'
import UserCell from '@/components/common/user-cell'
import VueClipboards from "vue-clipboards";
Vue.use(Panel)
    .use(Cell)
    .use(Button)
    .use(Tag)
    .use(Icon)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(Image)
    .use(ImagePreview)
    .use(VueClipboards)
    .use(Rate);
export default {
  name: 'order-rate-detail  ',
  components:{
    UserCell
  },
  data () {
    return {
      model: null,
      userCell:{
        id:null,
        name:null,
        headImgUrl:null,
        avatarFrameUrl:null,
        levelName:null,
        subscribe:null,
        isBlacklist:null,
      }
    }
  },
  computed: {
    copyUserWechatId() {
      if (this.model) {
        return this.model.userWechatId;
      }
      return null;
    }
  },
  methods: {
    //判断权限
    isAuthority(catalogue){
      return this.$LeaderAccess.includes(catalogue)
    },
    gotoOrderDetail(orderId) {
      this.$router.push('/leader/order/detail/'+orderId)
    },
    getUserCell(){
      this.userCell.id=this.model.userId
      this.userCell.name=this.model.userNickname
      this.userCell.headImgUrl=this.model.userHeadImgUrl
      this.userCell.avatarFrameUrl=this.model.avatarFrameUrl
      this.userCell.levelName=this.model.levelName
      this.userCell.subscribe=this.model.subscribe
      this.userCell.isBlacklist=this.model.isBlacklist
    },
    violationImg(photoUrls,index){
      ImagePreview({
        images: photoUrls,
        startPosition: index
      })
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
    // 格式化时间差
    formatTimeDiff(start, end,status) {
      start = moment(start)
      end = moment(end)
      const diffSeconds = end.diff(start, 'seconds')
      if (status === 2 && diffSeconds < 1) {
        return '即将完成'
      }
      if (diffSeconds < 60) {
        return `${diffSeconds}秒`
      }
      const diffMinutes = end.diff(start, 'minutes')
      if (diffMinutes < 60) {
        return `${diffMinutes}分钟`
      }
      const diffHours = end.diff(start, 'hours')
      if (diffHours < 24) {
        return `${diffHours}小时`
      }
      const diffDays = end.diff(start, 'days')
      return `${diffDays}天`
    },
    // 修改显示状态
    updateIsShow(id, isShow) {
      Toast.loading({
        mask: true,
        message: '请稍后...'
      })
      let op = isShow ? '显示' : '隐藏'
      updateIsShow(id, isShow).then((res) => {
        Toast.clear()
        const data = res.data
        if (data.code == 0) {
          this.model.isShow=isShow
          Toast(op+'成功')
        } else {
          Dialog.alert({
            title: op+'失败',
            message: data.msg
          })
        }
      })
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getRate(this.$route.params.id).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.model = data.orderRate;
          this.getUserCell()
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
  },
  mounted() {
    this.loadData()
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>

.page {
  padding-bottom: 100px;

  .panel-info {
    margin-top: 10px;
    .cell-padding{
      padding: 5px 15px 10px;

      .user-item {
        display: flex;
        align-items: center;
        .userMemo {
          color: #999;
        }
        .left {
          flex: 1;
          display: flex;
          .service-info {
            color: #333;
          }
          .created {
            color: #555;
            margin-bottom: 5px;
          }
          .user_head {
            position: relative;
            padding: 10px;
            .avatarFrame {
              position: absolute;
              top: 0;
              left: 0;
            }
            .level {
              position: absolute;
              left: 50%;
              height: 10px;
              font-size: 10px;
              white-space: nowrap;
              bottom: 0px;
              transform: translateX(-50%);
            }
          }
          .padding-left-sm div span{
            margin-right: 4px;
          }
          .recommend{
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            color: #999999;
          }
        }
        .right {
          text-align: right;
          min-width: 30px;
          .total-amount {
            color: #333;
          }
        }
      }
    }
    .content {
      font-size: 14px;
      padding: 0 15px 10px;
      .row {
        display: flex;
        color: #333;
        margin: 10px 0;
        align-items: center;
      }
      .label {
        width: 80px;
        color: #888;
      }

      .value {
        flex: 1;
      }
    }
  }

  .commentBox{
    width: 100%;
    background: #fff;
    padding: 15px;
    margin-top: 20px;
    box-sizing: border-box;
  }
  .imgStyle{
    margin-left: 10px;
    flex: 0 0 15%;
    height: 0;
    padding-bottom: 15%;
    overflow: hidden;
    position: relative;
  }
  .screenshot{
    width: 100%;
    display: flex;
    align-content: flex-start;
    flex-flow: row wrap;
  }
  .screenshotImg{
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.img-css{
  cursor: pointer;
  color:#2D8cF0;
}
.detail-row {
  display: flex;
  flex-direction: row !important;
  .item {
    display: flex;
    flex-direction: column !important;
    margin-left: 24px;
    .item-label {
      width: 80px;
      color: #333;
    }
  }
}
</style>
